import { render, staticRenderFns } from "./UploadLink.vue?vue&type=template&id=445b0ac4&scoped=true"
import script from "./UploadLink.vue?vue&type=script&lang=js"
export * from "./UploadLink.vue?vue&type=script&lang=js"
import style0 from "./UploadLink.vue?vue&type=style&index=0&id=445b0ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b0ac4",
  null
  
)

export default component.exports